import { render, staticRenderFns } from "./RecommendTable.vue?vue&type=template&id=85f5ae3c"
import script from "./RecommendTable.vue?vue&type=script&lang=js"
export * from "./RecommendTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports